// extracted by mini-css-extract-plugin
module.exports = {"divider":"menuBar_divider__11mmV","container":"menuBar_container__2Oji-"};